/**
 * Класс AbstractLogicalGeometryOperationResult определяет структуру результата геометрической операции
 */
class AbstractLogicalGeometryOperationResult {
  /**
   * Создание экземпляра класса AbstractLogicalGeometryOperationResult
   * @param {object} params
   * @param {object} params.result - возвращает true или false
   */
  constructor(params) {
    this.type = "AbstractLogicalGeometryOperationResult";
    this.result = params.result;

  }
}

module.exports = AbstractLogicalGeometryOperationResult;